import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { PerfectScrollbarModule } from "ngx-perfect-scrollbar";
import { MaterialModule } from "../../material.module";
import { AdvancedSearchComponent } from "./advanced-search/advanced-search.component";
import { AppletLogoComponent } from "./applet-logo/applet-logo.component";
import { BreadcrumbComponent } from "./breadcrumb/breadcrumb.component";
import { ColumnToggleComponent } from "./column-toggle/column-toggle.component";
import { CreditTermsComponent } from "./credit-terms/credit-terms.component";
import { CurrencyComponent } from "./currency/currency.component";
import { DragDropDirective } from "./drag-drop.directive";
import { FirstColumnDirective } from "./first-column.directive";
import { FourOhFourComponent } from "./four-oh-four/four-oh-four.component";
import { GridToggleComponent } from "./grid-toggle/grid-toggle.component";
import { PaginationComponent } from "./pagination/pagination.component";
import { PermissionDirective } from "./permission.directive";
import { PricingSchemeUOMComponent } from "./pricing-scheme-uom/pricing-scheme-uom.component";
import { SalesAgentComponent } from "./sales-agent/sales-agent.component";
import { SalesAgentSearchComponent } from "./sales-agent-v2/sales-agent.component";
import { SalesManComponent } from "./sales-man/sales-man.component";
import { SecondColumnDirective } from "./second-column.directive";
import { SelectSettlementMethodComponent } from "./select-settlement-method/select-settlement-method.component";
import { SSTComponent } from "./sst/sst.component";
import { WHTComponent } from "./wht/wht.component";
import { SelectSetOfBooksDropDownComponent } from "./select-set-of-books-drop-down/select-set-of-books-drop-down.component";
import * as moment from "moment";
import { AdvancedSearchLinesComponent } from "./advanced-search-lines/advanced-search-lines.component";
import { LineContainerKoByComponent } from "./line-container-ko-by/line-container-ko-by.component";
import { LineContainerKoForComponent } from "./line-container-ko-for/line-container-ko-for.component";
import { LineContainerKoForQueueComponent } from "./line-container-ko-for-queue/line-container-ko-for-queue.component";
import { AgGridModule } from "ag-grid-angular";
import { DocLinkKoForComponent } from "./doc-link-ko-for/doc-link-ko-for.component";
import { DocLinkKoByComponent } from "./doc-link-ko-by/doc-link-ko-by.component";
import { UOMComponent } from "./uom/uom.component";
import { SelectMultiLocationDropDownComponent } from "./select-multi-location-drop-down/select-multi-location-drop-down.component";
import { SelectMultiLocationDropDownStockReportComponent } from "./select-multi-location-drop-down-stock-report/select-multi-location-drop-down-stock-report.component"
import { PaginationClientSideComponent } from "./pagination-client-side/pagination-client-side.component";
import { ErpSelectGlcodeDropDownComponent } from "./select-glcode-drop-down/select-glcode-drop-down.component";
import { GenericDocumentPostingComponent } from "./generic-document-posting/generic-document-posting.component";
import { JournalTxnComponent } from "./generic-document-posting/journal-txn/journal-txn.component";
import { CashbookTxnComponent } from "./generic-document-posting/cashbook-txn/cashbook-txn.component";
import { TaxTxnComponent } from "./generic-document-posting/tax-txn/tax-txn.component";
import { PointsTxnComponent } from "./generic-document-posting/points-txn/points-txn.component";
import { InvTxnComponent } from "./generic-document-posting/inv-txn/inv-txn.component";
import { PermissionHideDirective } from "./permissionHide.directive";
import { SelectSubledgerComponent } from "./select-subledger/select-subledger.component";
import { BranchComponent } from "./branch/branch.component";
import { AdvancedSearchV2Component } from "./advanced-search-v2/advanced-search-v2.component";
import { LocationFromComponent } from "./location-from/location-from.component";
import { LocationToComponent } from "./location-to/location-to.component";
import { AppletComponent } from "./applet/applet.component";
import { WorkflowProcessComponent } from "./workflow-process/workflow-process.component";
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from "@angular/material/snack-bar";
import { SelectMultiBranchDropDownComponent } from "./select-multi-branch-drop-down/select-multi-branch-drop-down.component";
import { PaginationClientSideV2Component } from "./pagination-client-side-v2/pagination-client-side-v2.component";
import { SelectPrintableFormatAppletLoginEpComponent } from "./select-printable-format-applet-login-ep/select-printable-format-applet-login-ep.component";
import { SalesManAppletLoginComponent } from "./sales-man-applet-login/sales-man-applet-login.component";
import { SelectTariffCodeComponent } from "./select-tariff-code/select-tariff-code.component";
import { UtilItemSerialNumberComponent } from "./serial-number/serial-number.component";
import { SerialNumberScanComponent } from "./serial-number/serial-number-scan/serial-number-scan.component";
import { SerialNumberListingComponent } from "./serial-number/serial-number-listing/serial-number-listing.component";
import { SerialNumberImportComponent } from "./serial-number/serial-number-import/serial-number-import.component";
import { CompanyComponent } from "./company/company.component";
import { CompanyV2 } from "./company-v2/company-v2.component";
import { PricingSchemeComponent } from "./pricing-scheme/pricing-scheme.component";
import { PersonInChargeComponent } from "./person-in-charge/person-in-charge.component";
import { SelectPrintableFormatComponent } from "./select-printable-format/select-printable-format.component";
import { TimestampTzDatatypeInterface, bl_fi_generic_doc_line_RowInterface } from "blg-akaun-ts-lib";
import { UtilLocationDropdownComponent } from "./util-location-dropdown/util-location-dropdown.component";
import { LocationDropdownStockComponent } from "./location-dropdown-stock/location-dropdown-stock.component";
import { PaginationV2Component } from "./pagination-v2/pagination-v2.component";
import { CommissionCycleDropDownComponent } from "./commission-cycle-dropdown/commission-cycle-dropdown.component";
import { SelectMultiCompanyDropDownComponent } from "./select-multi-company-drop-down/select-multi-company-drop-down.component";
import { SelectMultiEntityDropDownComponent } from "./select-multi-entity-drop-down/select-multi-entity-drop-down.component";
import { AdvancedSearchGeneralComponent } from "./advanced-search-general/advanced-search-general.component";
import { SelectMultiLabelListDropDownComponent } from "./select-multi-label-list-drop-down/select-multi-label-list-drop-down.component";
import { SelectMultiItemCategoryLevelDropDownComponent } from "./select-multi-item-category-level-drop-down/select-multi-item-category-level-drop-down.component";
import { RecurrenceEditorComponentComponent } from './recurrence-editor-component/recurrence-editor-component.component';
import { EInvoiceRecurrenceEditorComponentComponent } from './e-invoice-recurrence-editor-component/e-invoice-recurrence-editor-component.component';
import { ExportStatusBarComponent } from "./status-bar/export-status-bar.component";
import { PaginationServerSideV2Component } from './pagination-server-side-v2/pagination-server-side-v2.component';
import { AdvancedSearchEntitiesComponent } from "./advanced-search-entities/advanced-search-entities.component";
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from "@angular/material/core";
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from "@angular/material-moment-adapter";
import { ExportButtonComponent } from "./export-button/export-button.component";
import { MonthYearPickerComponent } from './month-year-picker/month-year-picker.component';
import { ParentPrintableDropdownComponent } from './parent-printable-dropdown/parent-printable-dropdown.component';
import { SelectEmailTemplateComponent } from "./select-email-template/select-email-template.component";
// import { SelectVehiclesDropdownComponent } from './select-vehicles-drop-down/select-vehicles-drop-down.component';
import { AdvancedSearchCashbookComponent } from "./advanced-search-cashbook/advanced-search-cashbook.component";
import { SelectGLCodeV2Component } from "./select-gl-code-v2/select-gl-code-v2.component";
import { NumericAGCellEditor } from "./numeric-ag-cell-editor/numeric-ag-cell-editor.component";
import { WholeNumberAGCellEditor } from "./numeric-ag-cell-editor/whole-number-ag-cell-editor.component";
import { SelectMultiCustomerDropDownComponent } from './select-multi-customer-drop-down/select-multi-customer-drop-down.component'
import { SelectMultiCustomerCategoryDropDownComponent } from './select-multi-customer-category-drop-down/select-multi-customer-category-drop-down.component'
import { WarehouseAdvancedSearchComponent } from "./warehouse-advanced-search-drop-down/warehouse-advanced-search-drop-down.component"
import { SelectEmployeeDropDownComponent } from "./select-employee-drop-down/select-employee-drop-down.component";
import { SelectWarehouseDropDownComponent } from "./select-warehouse-drop-down/select-warehouse-drop-down.component";
import { CompanyWorkflowDropdownComponent } from "./company-workflow-dropdown/company-workflow-dropdown.component";
import { PricingSchemeV2Component } from "./pricing-scheme-v2/pricing-scheme-v2.component";
import { RefreshComponent } from "./refresh/refresh.component";
import { UOMV2Component } from "./uom-v2/uom-v2.component";
import { RequireDeliveryCellRendererComponent } from "./require-delivery-cell-renderer/require-delivery-cell-renderer.component";
import { DeliveryTypeCellRendererComponent } from "./delivery-type-cell-renderer/delivery-type-cell-renderer.component";
import { SelectMultiCurrencyDropDownComponent } from "./select-multi-currency-drop-down/select-multi-currency-drop-down.component";
import { UomWmsItemComponent } from "./uom-wms-item/uom-wms-item.component"
import { CustomTooltipComponent } from './custom-tooltip/custom-tooltip.component';
import { CustomLoadingOverlayComponent } from './custom-loading-overlay/custom-loading-overlay.component';
import { PaginationClientSideV3Component } from './pagination-client-side-v3/pagination-client-side-v3.component';
import { AdvancedSearchWmsItemsComponent } from "./advanced-search-wms-items/advanced-search-wms-items.component";
import { SelectIntercompanyBranchDownComponent } from "./select-intercompany-branch-drop-down/select-intercompany-branch-drop-down.component";
import { PurchaserComponent } from "./purchaser/purchaser.component";
import { CashbookAdvancedSearchDropdownComponent } from "./advanced-search-cashbook-dropdown/advanced-search-cashbook-dropdown.component";
import { SelectGLCategryDropDownComponent } from './select-glcategory-drop-down/select-glcategory-drop-down.component';
import { SerialNumberOptionalComponent } from './serial-number-optional/serial-number-optional.component';
import { SerialNumberImportOptionalComponent } from './serial-number-optional/serial-number-import-optional/serial-number-import-optional.component';
import { SerialNumberScanOptionalComponent } from './serial-number-optional/serial-number-scan-optional/serial-number-scan-optional.component';
import { SelectMultiGLCodeDropDownComponent } from "./select-multi-glcode-drop-down/select-multi-glcode-drop-down.component";
import { SelectMultiDeviceDropDownComponent } from "./select-multi-device-drop-down/select-multi-device-drop-down.component";
import { SelectMultiChartOfAccountDropDownComponent } from "./select-multi-chart-of-account-drop-down/select-multi-chart-of-account-drop-down.component";
import { SelectMultiGLCategoryDropDownComponent } from "./select-multi-glcategory-drop-down/select-multi-glcategory-drop-down.component";
import { ButtonRendererComponent } from "./button-renderer/button-renderer.component";
import { AkaunConfirmationDialogComponent } from "./dialogues/akaun-confirmation-dialog/akaun-confirmation-dialog";
import { AkaunMessageDialogComponent } from "./dialogues/akaun-message-dialog/akaun-message-dialog";
import { WorkflowActionComponent } from "./workflow-action/workflow-action.component";
import { WorkflowActionTypeComponent } from "./workflow-action-type/workflow-action-type.component";
import { WmsContainerAdvancedSearchDropdownComponent } from "./advanced-search-wms-container-dropdown/advanced-search-wms-container-dropdown.component";
import { WmsLayoutNodeAdvancedSearchDropdownComponent } from "./advanced-search-wms-layout-node-dropdown/advanced-search-wms-layout-node-dropdown.component";
import { TimezoneDropdownComponent } from "./timezone-dropdown/timezone-dropdown.component";
import { PrintablePageComponent } from "./printable-page/printable-page.component";
import { SelectPricebookComponent } from "./pricebook/pricebook.component";
import { SelectMultiGLSectionDropDownComponent } from "./select-multi-glsection-drop-down/select-multi-glsection-drop-down.component";
import { SelectLocationDropDownLatestComponent } from "./blg-select-location-drop-down-latest/blg-select-location-drop-down-latest.component";
import { SelectNSTIDropDownComponent } from "./select-nsti-drop-down/select-nsti-drop-down.component";
import { SelectPrintableFormatWithFilterComponent } from './select-printable-format-with-filter/select-printable-format-with-filter/select-printable-format-with-filter.component';
import { SelectBudgetItemComponent } from './select-budget-item/select-budget-item.component';
import { SelectBudgetRegisterComponent } from './select-budget-register/select-budget-register.component';
import { SelectBudgetFiscalYearComponent } from './select-budget-fiscal-year/select-budget-fiscal-year.component';
import { SelectBudgetVotebookGenDocComponent } from './select-budget-votebook-gen-doc/select-budget-votebook-gen-doc.component';
import { SelectBudgetRegisterGenDocComponent } from './select-budget-register-gen-doc/select-budget-register-gen-doc.component';
import { SelectBudgetFiscalPeriodGenDocComponent } from './select-budget-fiscal-period-gen-doc/select-budget-fiscal-period-gen-doc.component';
import { SelectBudgetItemGenDocComponent } from './select-budget-item-gen-doc/select-budget-item-gen-doc.component';
import { SelectBudgetFiscalYearGenDocComponent } from './select-budget-fiscal-year-gen-doc/select-budget-fiscal-year-gen-doc.component';
import { AdvancedSearchClientSideComponent } from "./advanced-search-client-side/advanced-search-client-side.component";
import { AkaunDiscardDialogComponent } from "../dialogues/akaun-discard-dialog/akaun-discard-dialog.component";
import { EinvoiceUOMComponent } from "../utilities/einvoice-uom/einvoice-uom.component"
import { SelectMultiEmployeeDropDownComponent } from "./select-multi-employee-drop-down/select-multi-employee-drop-down.component";
import { AkaunVoidDialogComponent } from "../dialogues/akaun-void-dialog/akaun-void-dialog.component";
import { SelectMultiDropDownComponent } from "./select-multi-drop-down/select-multi-drop-down.component";
import { SelectMultiFiItemDropDownComponent } from "./select-multi-fi-item-drop-down/select-multi-fi-item-drop-down.component";
import { CloseConfirmDialogComponent } from './close-confirmation-popup/close-confirm-dialog.component';
import { RejectionReasonPopUpComponent } from "./einvoice-request-rejection-reason-popup/rejection-popup.component";
import { DefaultLanguageSelectDropDownComponent } from "./default-language-select-drop-down/default-language-select-drop-down.component";
import { SelectMultiPricingSchemeDropDownComponent } from "./select-multi-pricing-scheme-drop-down/select-multi-pricing-scheme-drop-down.component";
import { SelectMultiLocationLabelDropDownComponent } from "./select-multi-location-label-drop-down/select-multi-location-label-drop-down.component";
import { SelectCustomerDropdownComponent } from './select-customer-dropdown/select-customer-dropdown.component';
import { ForexDataSourceComponent } from "./forex-data-source-drop-down/forex-data-source-drop-down.component";
import { RoleDropdownComponent } from './role-dropdown/role-dropdown.component';
import { ConsulationNoDropdownComponent } from './consultation-no-dropdown/consultation-no-dropdown.component';
import { ConsulationNameDropdownComponent } from './consultation-name-dropdown/consultation-name-dropdown.component';
import { VehicleNoDropdownComponent } from "./vehicle-no-dropdown/vehicle-no-dropdown.component";
import { VehicleBrandNameDropdownComponent } from "./vehicle-brand-name-dropdown/vehicle-brand-name-dropdown.component";
import { VehicleCapacityDropdownComponent } from "./vehicle-capacity-dropdown/vehicle-capacity-dropdown.component";
import { VehicleModelYearDropdownComponent } from "./vehicle-model-year-dropdown/vehicle-model-year-dropdown.component";
import { AdvancedSearchLinesV2Component } from './advanced-search-lines-v2/advanced-search-lines-v2.component';
import { SelectMultiItemCategoryDropDownComponent } from './select-multi-item-category-drop-down/select-multi-item-category-drop-down.component';
import { SelectMultiCashbookDropDownComponent } from "./select-multi-cashbook-drop-down/select-multi-cashbook-drop-down.component";
import { EscapeHtmlPipe } from "./Pipe/escape-html.pipe";
import { SelectItemGlCodeComponent } from './select-item-gl-code/select-item-gl-code.component';
import { SelectMultiTaxCodeDropDownComponent } from "./select-multi-tax-code-drop-down/select-multi-tax-code-drop-down.component";
import { AdvancedSearchEInvoiceComponent } from "./advanced-search-einvoice/advanced-search-einvoice.component";
import { AdvancedSearchEInvoicePortalComponent } from "./advanced-search-einvoice-portal/advanced-search-einvoice-portal.component";
import { BranchDropdownSimpleComponent } from "./branch-dropdown-simple/branch-dropdown-simple.component";
import { CustomerDropdownSimpleComponent } from "./customer-dropdown-simple/customer-dropdown-simple.component";
import { ExportDataDialogComponent } from "./export-data-dialog/export-data-dialog.component";
import { SelectSupplierDropdownComponent } from './select-supplier-dropdown/select-supplier-dropdown.component';
import { SelectMultiLocationDropdownComponent } from './select-multi-location-dropdown/select-multi-location-dropdown.component';
import { PaginationV2EntityComponent } from "./pagination-v2-entity/pagination-v2-entity.component";
import { AkaunGenDocLockDialogComponent } from "../dialogues/akaun-gen-doc-lock-dialog/akaun-gen-doc-lock-dialog.component";
import { MultiLevelDiscountComponent } from './multi-level-discount/multi-level-discount.component';
import { GenericDocumentViewMainComponent } from "./generic-document-view-main/generic-document-view-main.component";
import { GenericDocumentViewLineComponent } from "./generic-document-view-line/generic-document-view-line.component";
import { GenericDocumentViewSettlementComponent } from "./generic-document-view-settlement/generic-document-view-settlement.component";
import { GenericDocumentViewExportComponent } from "./generic-document-view-export/generic-document-view-export.component";
import { CashDocumentViewMainComponent } from "./cash-document-view-main/cash-document-view-main.component";
import { CashDocumentViewLineComponent } from "./cash-document-view-line/cash-document-view-line.component";
import { CashDocumentPostingComponent } from "./cash-document-posting/cash-document-posting.component";
import { CashDocumentPostingJournalTxnComponent } from "./cash-document-posting/journal-txn/journal-txn.component";
import { CashDocumentPostingCashbookTxnComponent } from "./cash-document-posting/cashbook-txn/cashbook-txn.component";
import { CashDocumentViewExportComponent } from "./cash-document-view-export/cash-document-view-export.component";
import { SupplierDropdownSimpleComponent } from "./supplier-dropdown-simple/supplier-dropdown-simple.component";
import { GenericDocumentViewComponent } from "./generic-document-view/generic-document-view.component";
import { CellClickHandlerComponent } from './cell-click-handler.component';
import { StoreModule } from '@ngrx/store';
import { columnViewModelFeatureKey, columnViewModelReducers } from '../generic-doc-view-model-controller/generic-doc-cashbook-view-model-controller/reducers/root';
import { columnViewModelFeatureKey1, columnViewModelReducers1 } from '../generic-doc-view-model-controller/generic-doc-journal-view-model-controller/reducers/root';
import { columnViewModelFeatureKey2, columnViewModelReducers2 } from '../generic-doc-view-model-controller/generic-doc-points-view-model-controller/reducers/root';
import { columnViewModelFeatureKey3, columnViewModelReducers3 } from '../generic-doc-view-model-controller/generic-doc-tax-view-model-controller/reducers/root';
import { columnViewModelFeatureKey4, columnViewModelReducers4 } from '../generic-doc-view-model-controller/generic-doc-inv-view-model-controller/reducers/root';
import { SelectRoundingItemComponent } from './select-rounding-item/select-rounding-item.component';
import { SelectGroupDiscountItemComponent } from './select-group-discount-item/select-group-discount-item.component';
import { SelectDefaultSettlementItemComponent } from './select-default-settlement-method/select-default-settlement-method.component';
import { UtilPricingSchemeHdrComponent } from './pricing-scheme-hdr/pricing-scheme-hdr.component';
import { SelectPosCardTerminalDropDownComponent } from './select-pos-card-terminal-drop-down/select-pos-card-terminal-drop-down.component';
import { CurrencyRateComponent } from './currency-rate/currency-rate.component';
import { AdvancedSearchPermSetComponent } from './advanced-search-perm-set/advanced-search-perm-set.component';
import { SelectMultiEmployeeDropDownV2Component } from "./select-multi-employee-drop-down-v2/select-multi-employee-drop-down-v2.component";

const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'YYYY-MM-DD',
    monthYearLabel: 'YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'YYYY',
  },
};

export const storeModule1 = StoreModule.forFeature(columnViewModelFeatureKey, columnViewModelReducers);
export const storeModule2 = StoreModule.forFeature(columnViewModelFeatureKey1, columnViewModelReducers1);
export const storeModule3 = StoreModule.forFeature(columnViewModelFeatureKey2, columnViewModelReducers2);
export const storeModule4 = StoreModule.forFeature(columnViewModelFeatureKey3, columnViewModelReducers3);
export const storeModule5 = StoreModule.forFeature(columnViewModelFeatureKey4, columnViewModelReducers4);

@NgModule({
  declarations: [
    AdvancedSearchComponent,
    PaginationComponent,
    AppletLogoComponent,
    ColumnToggleComponent,
    GridToggleComponent,
    BreadcrumbComponent,
    FourOhFourComponent,
    CurrencyComponent,
    ForexDataSourceComponent,
    CreditTermsComponent,
    SelectSettlementMethodComponent,
    SalesAgentSearchComponent,
    SalesAgentComponent,
    SalesManComponent,
    SSTComponent,
    WHTComponent,
    DragDropDirective,
    FirstColumnDirective,
    SecondColumnDirective,
    PermissionDirective,
    PricingSchemeUOMComponent,
    SelectSetOfBooksDropDownComponent,
    AdvancedSearchLinesComponent,
    LineContainerKoByComponent,
    LineContainerKoForComponent,
    LineContainerKoForQueueComponent,
    DocLinkKoForComponent,
    DocLinkKoByComponent,
    UOMComponent,
    SelectMultiLocationDropDownComponent,
    SelectMultiLocationDropDownStockReportComponent,
    PaginationClientSideComponent,
    ErpSelectGlcodeDropDownComponent,
    GenericDocumentPostingComponent,
    JournalTxnComponent,
    CashbookTxnComponent,
    TaxTxnComponent,
    PointsTxnComponent,
    InvTxnComponent,
    PermissionHideDirective,
    SelectSubledgerComponent,
    BranchComponent,
    // SelectVehiclesDropdownComponent,
    AdvancedSearchV2Component,
    LocationFromComponent,
    LocationToComponent,
    AppletComponent,
    SelectMultiBranchDropDownComponent,
    WorkflowProcessComponent,
    WorkflowActionComponent,
    WorkflowActionTypeComponent,
    PaginationClientSideV2Component,
    SelectPrintableFormatAppletLoginEpComponent,
    SalesManAppletLoginComponent,
    SelectTariffCodeComponent,
    UtilItemSerialNumberComponent,
    SerialNumberScanComponent,
    SerialNumberListingComponent,
    SerialNumberImportComponent,
    CompanyComponent,
    CompanyV2,
    PricingSchemeComponent,
    PersonInChargeComponent,
    SelectPrintableFormatComponent,
    UtilLocationDropdownComponent,
    LocationDropdownStockComponent,
    PaginationV2Component,
    CommissionCycleDropDownComponent,
    SelectMultiCompanyDropDownComponent,
    SelectMultiEntityDropDownComponent,
    PaginationServerSideV2Component,
    AdvancedSearchEntitiesComponent,
    AdvancedSearchGeneralComponent,
    SelectMultiLabelListDropDownComponent,
    SelectMultiItemCategoryLevelDropDownComponent,
    RecurrenceEditorComponentComponent,
    EInvoiceRecurrenceEditorComponentComponent,
    ExportStatusBarComponent,
    ExportButtonComponent,
    MonthYearPickerComponent,
    ParentPrintableDropdownComponent,
    SelectEmailTemplateComponent,
    AdvancedSearchCashbookComponent,
    SelectGLCodeV2Component,
    NumericAGCellEditor,
    WholeNumberAGCellEditor,
    SelectMultiCustomerDropDownComponent,
    SelectMultiCustomerCategoryDropDownComponent,
    WarehouseAdvancedSearchComponent,
    SelectEmployeeDropDownComponent,
    SelectWarehouseDropDownComponent,
    CompanyWorkflowDropdownComponent,
    PricingSchemeV2Component,
    RefreshComponent,
    UOMV2Component,
    RequireDeliveryCellRendererComponent,
    DeliveryTypeCellRendererComponent,
    SelectMultiCurrencyDropDownComponent,
    UomWmsItemComponent,
    CustomTooltipComponent,
    CustomLoadingOverlayComponent,
    PaginationClientSideV3Component,
    AdvancedSearchWmsItemsComponent,
    SelectIntercompanyBranchDownComponent,
    PurchaserComponent,
    CashbookAdvancedSearchDropdownComponent,
    SelectGLCategryDropDownComponent,
    SerialNumberOptionalComponent,
    SerialNumberImportOptionalComponent,
    SerialNumberScanOptionalComponent,
    SelectMultiGLCodeDropDownComponent,
    SelectMultiDeviceDropDownComponent,
    SelectMultiChartOfAccountDropDownComponent,
    SelectMultiGLCategoryDropDownComponent,
    ButtonRendererComponent,
    AkaunConfirmationDialogComponent,
    AkaunMessageDialogComponent,
    WmsContainerAdvancedSearchDropdownComponent,
    WmsLayoutNodeAdvancedSearchDropdownComponent,
    TimezoneDropdownComponent,
    PrintablePageComponent,
    SelectPricebookComponent,
    SelectMultiGLSectionDropDownComponent,
    SelectLocationDropDownLatestComponent,
    SelectNSTIDropDownComponent,
    SelectPrintableFormatWithFilterComponent,
    SelectBudgetItemComponent,
    SelectBudgetRegisterComponent,
    SelectBudgetFiscalYearComponent,
    SelectBudgetVotebookGenDocComponent,
    SelectBudgetRegisterGenDocComponent,
    SelectBudgetFiscalPeriodGenDocComponent,
    SelectBudgetItemGenDocComponent,
    SelectBudgetFiscalYearGenDocComponent,
    AdvancedSearchClientSideComponent,
    DefaultLanguageSelectDropDownComponent,
    AkaunDiscardDialogComponent,
    EinvoiceUOMComponent,
    SelectMultiEmployeeDropDownComponent,
    AkaunVoidDialogComponent,
    SelectMultiDropDownComponent,
    SelectMultiFiItemDropDownComponent,
    CloseConfirmDialogComponent,
    RejectionReasonPopUpComponent,
    SelectMultiPricingSchemeDropDownComponent,
    SelectMultiPricingSchemeDropDownComponent,
    SelectMultiLocationLabelDropDownComponent,
    SelectMultiPricingSchemeDropDownComponent,
    SelectCustomerDropdownComponent,
    RoleDropdownComponent,
    AdvancedSearchLinesV2Component,
    SelectMultiItemCategoryDropDownComponent,
    ConsulationNoDropdownComponent,
    ConsulationNameDropdownComponent,
    VehicleNoDropdownComponent,
    VehicleBrandNameDropdownComponent,
    VehicleCapacityDropdownComponent,
    VehicleModelYearDropdownComponent,
    SelectMultiCashbookDropDownComponent,
    EscapeHtmlPipe,
    SelectItemGlCodeComponent,
    SelectMultiTaxCodeDropDownComponent,
    AdvancedSearchEInvoiceComponent,
    AdvancedSearchEInvoicePortalComponent,
    BranchDropdownSimpleComponent,
    CustomerDropdownSimpleComponent,
    ExportDataDialogComponent,
    SelectSupplierDropdownComponent,
    SelectMultiLocationDropdownComponent,
    PaginationV2EntityComponent,
    AkaunGenDocLockDialogComponent,
    MultiLevelDiscountComponent,
    GenericDocumentViewMainComponent,
    GenericDocumentViewLineComponent,
    GenericDocumentViewSettlementComponent,
    GenericDocumentViewExportComponent,
    CashDocumentViewMainComponent,
    CashDocumentViewLineComponent,
    CashDocumentPostingComponent,
    CashDocumentPostingJournalTxnComponent,
    CashDocumentPostingCashbookTxnComponent,
    CashDocumentViewExportComponent,
    SupplierDropdownSimpleComponent,
    CellClickHandlerComponent,
    GenericDocumentViewComponent,
    SelectRoundingItemComponent,
    SelectGroupDiscountItemComponent,
    SelectDefaultSettlementItemComponent,
    UtilPricingSchemeHdrComponent,
    SelectPosCardTerminalDropDownComponent,
    CurrencyRateComponent,
    SelectMultiEmployeeDropDownV2Component,
    AdvancedSearchPermSetComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    PerfectScrollbarModule,
    NgxMatSelectSearchModule,
    AgGridModule,
    storeModule1,
    storeModule2,
    storeModule3,
    storeModule4,
    storeModule5
  ],
  exports: [
    AdvancedSearchComponent,
    PaginationComponent,
    AppletLogoComponent,
    ColumnToggleComponent,
    GridToggleComponent,
    BreadcrumbComponent,
    CurrencyComponent,
    ForexDataSourceComponent,
    CreditTermsComponent,
    SelectSettlementMethodComponent,
    SalesAgentComponent,
    SalesAgentSearchComponent,
    SalesManComponent,
    SSTComponent,
    WHTComponent,
    MaterialModule,
    FormsModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    PerfectScrollbarModule,
    NgxMatSelectSearchModule,
    DragDropDirective,
    FirstColumnDirective,
    SecondColumnDirective,
    PermissionDirective,
    PricingSchemeUOMComponent,
    SelectSetOfBooksDropDownComponent,
    AdvancedSearchLinesComponent,
    LineContainerKoByComponent,
    LineContainerKoForComponent,
    LineContainerKoForQueueComponent,
    DocLinkKoForComponent,
    DocLinkKoByComponent,
    UOMComponent,
    SelectMultiLocationDropDownComponent,
    SelectMultiLocationDropDownStockReportComponent,
    PaginationClientSideComponent,
    ErpSelectGlcodeDropDownComponent,
    GenericDocumentPostingComponent,
    JournalTxnComponent,
    CashbookTxnComponent,
    TaxTxnComponent,
    PointsTxnComponent,
    InvTxnComponent,
    PermissionHideDirective,
    SelectSubledgerComponent,
    AdvancedSearchV2Component,
    BranchComponent,
    // SelectVehiclesDropdownComponent,
    LocationFromComponent,
    LocationToComponent,
    AppletComponent,
    SelectMultiBranchDropDownComponent,
    WorkflowProcessComponent,
    WorkflowActionComponent,
    WorkflowActionTypeComponent,
    PaginationClientSideV2Component,
    SelectPrintableFormatAppletLoginEpComponent,
    SalesManAppletLoginComponent,
    SelectTariffCodeComponent,
    UtilItemSerialNumberComponent,
    SerialNumberScanComponent,
    SerialNumberListingComponent,
    SerialNumberImportComponent,
    PricingSchemeComponent,
    PersonInChargeComponent,
    SelectPrintableFormatComponent,
    UtilLocationDropdownComponent,
    PaginationV2Component,
    CommissionCycleDropDownComponent,
    LocationDropdownStockComponent,
    SelectMultiCompanyDropDownComponent,
    SelectMultiEntityDropDownComponent,
    PaginationServerSideV2Component,
    AdvancedSearchEntitiesComponent,
    AdvancedSearchGeneralComponent,
    SelectMultiLabelListDropDownComponent,
    SelectMultiItemCategoryLevelDropDownComponent,
    RecurrenceEditorComponentComponent,
    EInvoiceRecurrenceEditorComponentComponent,
    ExportStatusBarComponent,
    ExportButtonComponent,
    ParentPrintableDropdownComponent,
    SelectEmailTemplateComponent,
    AdvancedSearchCashbookComponent,
    SelectGLCodeV2Component,
    MonthYearPickerComponent,
    SelectMultiCustomerDropDownComponent,
    SelectMultiCustomerCategoryDropDownComponent,
    WarehouseAdvancedSearchComponent,
    SelectEmployeeDropDownComponent,
    SelectWarehouseDropDownComponent,
    CompanyWorkflowDropdownComponent,
    PricingSchemeV2Component,
    RefreshComponent,
    UOMV2Component,
    RequireDeliveryCellRendererComponent,
    DeliveryTypeCellRendererComponent,
    SelectMultiCurrencyDropDownComponent,
    UomWmsItemComponent,
    CustomTooltipComponent,
    CustomLoadingOverlayComponent,
    PaginationClientSideV3Component,
    AdvancedSearchWmsItemsComponent,
    SelectIntercompanyBranchDownComponent,
    PurchaserComponent,
    CashbookAdvancedSearchDropdownComponent,
    SelectGLCategryDropDownComponent,
    SerialNumberOptionalComponent,
    SerialNumberImportOptionalComponent,
    SerialNumberScanOptionalComponent,
    SelectMultiGLCodeDropDownComponent,
    SelectMultiDeviceDropDownComponent,
    SelectMultiChartOfAccountDropDownComponent,
    SelectMultiGLCategoryDropDownComponent,
    ButtonRendererComponent,
    AkaunConfirmationDialogComponent,
    AkaunMessageDialogComponent,
    WmsContainerAdvancedSearchDropdownComponent,
    WmsLayoutNodeAdvancedSearchDropdownComponent,
    TimezoneDropdownComponent,
    PrintablePageComponent,
    SelectPricebookComponent,
    SelectMultiGLSectionDropDownComponent,
    SelectLocationDropDownLatestComponent,
    SelectNSTIDropDownComponent,
    SelectPrintableFormatWithFilterComponent,
    SelectBudgetItemComponent,
    SelectBudgetRegisterComponent,
    SelectBudgetFiscalYearComponent,
    SelectBudgetVotebookGenDocComponent,
    SelectBudgetRegisterGenDocComponent,
    SelectBudgetFiscalPeriodGenDocComponent,
    SelectBudgetItemGenDocComponent,
    SelectBudgetFiscalYearGenDocComponent,
    AdvancedSearchClientSideComponent,
    DefaultLanguageSelectDropDownComponent,
    AkaunDiscardDialogComponent,
    EinvoiceUOMComponent,
    SelectMultiEmployeeDropDownComponent,
    AkaunVoidDialogComponent,
    SelectMultiDropDownComponent,
    SelectMultiFiItemDropDownComponent,
    CloseConfirmDialogComponent,
    RejectionReasonPopUpComponent,
    SelectMultiPricingSchemeDropDownComponent,
    SelectMultiPricingSchemeDropDownComponent,
    SelectMultiLocationLabelDropDownComponent,
    SelectMultiPricingSchemeDropDownComponent,
    SelectCustomerDropdownComponent,
    RoleDropdownComponent,
    AdvancedSearchLinesV2Component,
    SelectMultiItemCategoryDropDownComponent,
    ConsulationNoDropdownComponent,
    ConsulationNameDropdownComponent,
    VehicleNoDropdownComponent,
    VehicleBrandNameDropdownComponent,
    VehicleCapacityDropdownComponent,
    VehicleModelYearDropdownComponent,
    SelectMultiCashbookDropDownComponent,
    EscapeHtmlPipe,
    SelectItemGlCodeComponent,
    SelectMultiTaxCodeDropDownComponent,
    AdvancedSearchEInvoiceComponent,
    AdvancedSearchEInvoicePortalComponent,
    BranchDropdownSimpleComponent,
    CustomerDropdownSimpleComponent,
    ExportDataDialogComponent,
    SelectSupplierDropdownComponent,
    SelectMultiLocationDropdownComponent,
    PaginationV2EntityComponent,
    AkaunGenDocLockDialogComponent,
    MultiLevelDiscountComponent,
    GenericDocumentViewMainComponent,
    GenericDocumentViewLineComponent,
    GenericDocumentViewSettlementComponent,
    GenericDocumentViewExportComponent,
    CashDocumentViewMainComponent,
    CashDocumentViewLineComponent,
    CashDocumentPostingComponent,
    CashDocumentPostingJournalTxnComponent,
    CashDocumentPostingCashbookTxnComponent,
    CashDocumentViewExportComponent,
    SupplierDropdownSimpleComponent,
    CellClickHandlerComponent,
    GenericDocumentViewComponent,
    SelectRoundingItemComponent,
    SelectGroupDiscountItemComponent,
    SelectDefaultSettlementItemComponent,
    UtilPricingSchemeHdrComponent,
    SelectPosCardTerminalDropDownComponent,
    CurrencyRateComponent,
    SelectMultiEmployeeDropDownV2Component,
    AdvancedSearchPermSetComponent
  ],
  providers: [
    { provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: { duration: 2500 } },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },
  ],
})
export class SharedUtilitiesModule {}
